import React from 'react';
import {
    Paper,
    Box,
    Typography,
    Grid,
    Divider,
    IconButton,
    Tooltip,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import StatusChip from '../shared/StatusChip';
import OverdueAttentionIndicator from '../shared/OverdueAttentionIndicator';
import ErrorDetailsBox from '../shared/ErrorDetailsBox';
import translations from '../../../constants/purchaseInvoices/translations/supplierInvoiceTranslations';


function InvoiceMobileCard({
    invoice,
    highlightedInvoiceId,
    highlightedInvoiceRef,
    isOverdueAttention,
    onActionsClick,
    onEditClick,
    styles
}) {
    return (
        <Paper
            elevation={isOverdueAttention(invoice) ? 4 : 1}
            sx={{
                ...styles.mobileCard,
                ...(isOverdueAttention(invoice) ? styles.overdueAttentionCard : {}),
                ...(invoice.id === highlightedInvoiceId ? styles.highlightAnimation : {}),
            }}
            ref={invoice.id === highlightedInvoiceId ? highlightedInvoiceRef : null}
        >
            <Box sx={styles.cardHeader}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
                        {isOverdueAttention(invoice) && (
                            <OverdueAttentionIndicator invoice={invoice} />
                        )}
                        <StatusChip invoice={invoice} styles={styles} />
                    </Box>
                    <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1.1rem' }}>
                        {invoice.supplierName}
                    </Typography>
                </Box>
            </Box>

            <Grid container spacing={2} sx={styles.cardGrid}>
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem' }}>
                            {translations.id}:
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 500, fontSize: '0.95rem' }}>
                            {invoice.booknum}
                        </Typography>
                    </Box>
                </Grid>
                
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem' }}>
                            {translations.date}:
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 500, fontSize: '0.95rem' }}>
                            {invoice.date ? invoice.date.replace(/\./g, '/') : '-'}
                        </Typography>
                    </Box>
                </Grid>
                
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem' }}>
                            {translations.uploadedAt}:
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 500, fontSize: '0.95rem' }}>
                            {invoice.uploadedAt
                                ? new Date(invoice.uploadedAt).toLocaleDateString('he-IL', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric'
                                }).replace(/\./g, '/')
                                : (invoice.date ? invoice.date.replace(/\./g, '/') : '-')
                            }
                        </Typography>
                    </Box>
                </Grid>
                
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem' }}>
                            {translations.amount}:
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 500, fontSize: '0.95rem' }}>
                            {Number(invoice.amount).toLocaleString()}
                        </Typography>
                    </Box>
                </Grid>
                
                {invoice.approver && (
                    <Grid item xs={12}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem' }}>
                                {translations.approver}:
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 500, fontSize: '0.95rem' }}>{invoice.approver}</Typography>
                        </Box>
                    </Grid>
                )}
            </Grid>

            <ErrorDetailsBox invoice={invoice} onEditClick={onEditClick} />

            <Divider sx={styles.cardDivider} />
            <Box sx={styles.cardFooter}>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Tooltip title="פעולות" arrow>
                        <IconButton
                            onClick={(e) => onActionsClick(e, invoice.id)}
                            size="small"
                            sx={styles.actionsMenuButton}
                        >
                            <MoreVertIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Box>
        </Paper>
    );
}

export default InvoiceMobileCard;
